import {
  get,
  post,
  patch,
  del,
} from '@/utils/request';

// 入职邀请
export function getInviteByToken(token) {
  return get({ url: 'onboard/invites', data: { token } });
}

export function inviteIndex(data) {
  return get({ url: 'administrator-invites', data });
}

export function inviteStore(data) {
  return post({ url: 'administrator-invites', data });
}

export function inviteShow(id) {
  return get({ url: `administrator-invites/${id}` });
}

export function inviteRevoke(id) {
  return patch({ url: `administrator-invites/${id}` });
}

// 入职申请
export function onboardApplySubmit(data) {
  return post({ url: 'onboard/applies', data });
}

// 入职页用户名即时查重（错误已在行内提示，避免重复弹 toast）
export function checkOnboardUsername(data) {
  return get({ url: 'onboard/check-username', data, isAutoShowErrorTip: false });
}

// 入职页手机号即时查重（错误已在行内提示，避免重复弹 toast）
export function checkOnboardPhone(data) {
  return get({ url: 'onboard/check-phone', data, isAutoShowErrorTip: false });
}

// 按邀请 token 查询最新申请状态（公开，无需登录）
export function onboardApplyStatus(data) {
  return get({ url: 'onboard/applies/status', data, isAutoShowErrorTip: false });
}

export function onboardApplyIndex(data) {
  return get({ url: 'administrator-onboard-applies', data });
}

export function onboardApplyShow(id) {
  return get({ url: `administrator-onboard-applies/${id}` });
}


export function onboardApplyReview(id, data) {
  return patch({ url: `administrator-onboard-applies/${id}`, data });
}

// 离职申请
export function offboardApplyIndex(data) {
  return get({ url: 'administrator-offboard-applies', data });
}

export function offboardApplyShow(id) {
  return get({ url: `administrator-offboard-applies/${id}` });
}

export function offboardApplyStore(data) {
  return post({ url: 'administrator-offboard-applies', data });
}

export function offboardApplyReview(id, data) {
  return patch({ url: `administrator-offboard-applies/${id}`, data });
}

export function offboardApplyRevoke(id) {
  return del({ url: `administrator-offboard-applies/${id}` });
}

export function administratorRehire(data) {
  return post({ url: 'administrator-rehires', data });
}

// 操作日志
export function operationLogIndex(data) {
  return get({ url: 'administrator-operation-logs', data });
}

// 操作日志详情（变更明细全量，供详情页使用）
export function operationLogShow(id) {
  return get({ url: `administrator-operation-logs/${id}` });
}

// 短信/密码
export function sendOnboardSms(data) {
  return post({ url: 'onboard/sms', data });
}

// 短信改密：需已登录，发送到当前账号绑定的手机号
export function sendProfilePasswordSms(data) {
  return post({ url: 'sms/profile-password', data });
}

// 更换手机号：向新手机号发送验证码（需已登录）
export function sendProfilePhoneSms(data) {
  return post({ url: 'sms/profile-phone', data });
}
